import React from "react";
import { getColorBy, getPaymentStatusBadgeContent } from "../../SelectList/PaymentsStatus";

export const PaymentListCell = ({
    paymentsStatus,
    practitioner,
    appointmentAuthor,
    appointmentStatus
}) => {

    const haveTransaction = () => {
        return paymentsStatus && paymentsStatus.transactions
    }
    const authorIsPractitioner = () => {
        return appointmentAuthor
            && practitioner
            && appointmentAuthor.id === practitioner.id
            && appointmentStatus === "CONFIRMED"
            && !haveTransaction()
    }

    if ( authorIsPractitioner() ) {
        return <p><b>En attente d'empreinte</b></p>
    }

    if (!haveTransaction()) {
        return <p><b>Pas de transactions</b></p>;
    }

    return (
        <details>
            <summary>Liste des transactions</summary>
            <div>
                { paymentsStatus.transactions.map((chargesList) => (
                    <div>
                        { chargesList.charges.map((charge) => (
                            <details>
                                <summary style={{ color: getColorBy(charge) }}>
                                    <b>{ getPaymentStatusBadgeContent(charge) }</b>
                                </summary>
                                <div className="mt-md-2 mb-md-2">
                                    amount: <b>{ charge.amount / 100 } euros</b><br/>
                                    charge id: <b>{charge.id}</b><br/>
                                    { charge.failure_code &&
                                        <p>erreur: <b>{ charge.failure_message }</b></p>
                                    }
                                </div>
                            </details>
                        ))}
                    </div>
                ))}
            </div>
        </details>
    );
}


// WEBPACK FOOTER //
// ./src/views/Dashboardlive/AppointmentsTable/Cell/PaymentListCell.js